<template>
  <div :class="classes">
      <pt-page-title title="退款订单"></pt-page-title>
      <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
            <template>
            <el-button type="primary" @click.native="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportRefund" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportRefundHistory">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
            </template>
      </pt-page-factor-filter>
      <pt-page-menu-filter :tabs="tabs" v-model="selectTab"></pt-page-menu-filter>
      <refund-table  :query-params="queryParams" :page-size="pageSize" ref="table" :selectTab="selectTab" :isFromRouter="isFromRouter">
              <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="refund_detail(scope.row)">详情</el-button>
                    <template v-if="HAS_REFUND_APPROVAL">
                        <el-button type="text" v-if="scope.row.refundmentDetails&&scope.row.refundmentDetails.status=='SUBMITTED'" @click="approve_refund(scope.row)">退款</el-button>
                        <el-button type="text" v-if="scope.row.refundmentDetails&&scope.row.refundmentDetails.status=='SUBMITTED'" @click="return_refund(scope.row)">驳回</el-button>
                     </template>
                </template>
              </el-table-column>
      </refund-table>
      <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['refund-dialog']" @close="closeDialog">
        <execute-refundment v-if="is_approve_refund" :orderDetail="refundDetail" @close="closeDialog"></execute-refundment>
        <turn-down v-if="is_return" :orderDetail="refundDetail" @close="closeDialog"></turn-down>
      </el-dialog>
  </div>
</template>

<script>
import { refundOrderLabels, refundOrderStatusTab } from '../goods-order-options'
import { orderRefundStatus } from 'json/goods-order-options'
import refundTable from './pt-refund-table/withData.vue'
import executeRefundment from './execute-refundment'
import turnDown from './turn-down'
import { hasPermissions } from 'utils/permissions'
import { emptyObject } from '@/utils/lifebankUtils'
// 订单退款审批权限
const PERM_MALLSALES_ORDER_REFUND_APPROVAL = 'PERM_MALLSALES_ORDER_REFUND_APPROVAL'
// 组件class前缀
const prefixCls = 'pt-refund-order-list'

export default {
  name: 'pt-refund-order-list',
  computed: {
    tableData () {
      return this.$refs.table.tableData
    },
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_approve_refund || this.is_return
      },
      set: function (val) {
        this.is_approve_refund = val
        this.is_return = val
      }
    },
    page () {
      return this.$refs.table.page
    },
    HAS_REFUND_APPROVAL () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_ORDER_REFUND_APPROVAL)
    }
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  components: {
    refundTable,
    executeRefundment,
    turnDown
  },
  data () {
    return {
      filterLabels: refundOrderLabels,
      tabs: refundOrderStatusTab,
      is_approve_refund: false,
      dialog_title: '',
      is_return: false,
      selectTab: '',
      refundDetail: {},
      params: {},
      queryParams: {
      },
      isFromRouter: false
    }
  },
  watch: {
    selectTab (val) {
      this.queryParams.orderRefundStatus = val && val !== 'all' ? val : this.params.orderRefundStatus
      this.selectTab = val
      let isHaveStatus = false
      if (val !== 'all') {
        this.filterLabels.forEach((item, index) => {
          if (item.value === 'orderRefundStatus') {
            this.filterLabels.splice(index, 1)
          }
        })
      } else {
        this.filterLabels.forEach((item, index) => {
          if (item.value === 'orderRefundStatus') {
            isHaveStatus = true
          }
        })
        if (!isHaveStatus) {
          this.filterLabels.push({
            label: '退款状态',
            type: 'select',
            clearable: true,
            value: 'orderRefundStatus',
            options: orderRefundStatus
          })
        }
      }
      if (!this.queryParams.orderRefundStatus) {
        this.$delete(this.queryParams, 'orderRefundStatus')
      }
    }
  },
  methods: {
    exportRefundHistory () {
      this.$router.push('/export-history/order?name=mall_order_export')
    },
    exportRefund () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.$emit('exportRefund', this.queryParams)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    cleanParams () {
      emptyObject(this.params)
      emptyObject(this.queryParams)
      if (this.selectTab !== 'all') {
        this.queryParams.orderRefundStatus = this.selectTab
      }
      this.Filter()
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'createdtime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
      if (this.selectTab === 'all') {
        this.queryParams = { ...this.params }
      } else {
        this.queryParams = { orderRefundStatus: this.queryParams.orderRefundStatus, ...this.params }
      }
    },
    approve_refund (val) {
      this.is_approve_refund = true
      this.dialog_title = '订单退款'
      this.refundDetail = val
    },
    closeDialog (val) {
      this.is_approve_refund = false
      this.is_return = false
      if (val) {
        this.$refs.table.refundList(0)
      }
    },
    return_refund (val) {
      this.is_return = true
      this.dialog_title = '退款驳回'
      this.refundDetail = val
    },
    refund_detail (val) {
      this.$router.push('/mall-order-refund/order-detail/' + val.id)
    }
  },
  created () {
    this.selectTab = this.$route.query.state
    this.queryParams.orderRefundStatus = this.selectTab && this.selectTab !== 'all' ? this.selectTab : null
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.refund-dialog{
    :global
    .el-dialog{
        width: 35%;
        margin: 0!important;
        max-width:550PX;
        min-width: 450PX;
        .el-dialog__body{
            padding: 10px 20px 25px;
        }
    }
}
</style>
<style lang="less">
.pt-refund-order-list{
    table{
        .el-button{
            margin-right: 10px;
            margin-left: 0
        }
    }
}
</style>
